__turbopack_context__.v({
  "additionalLinks": "Video-module-scss-module__Mv1anG__additionalLinks",
  "author": "Video-module-scss-module__Mv1anG__author",
  "bigContainer": "Video-module-scss-module__Mv1anG__bigContainer",
  "bigImage": "Video-module-scss-module__Mv1anG__bigImage",
  "bigLockedImage": "Video-module-scss-module__Mv1anG__bigLockedImage",
  "centredOverlay": "Video-module-scss-module__Mv1anG__centredOverlay",
  "container": "Video-module-scss-module__Mv1anG__container",
  "date": "Video-module-scss-module__Mv1anG__date",
  "description": "Video-module-scss-module__Mv1anG__description",
  "linksHeader": "Video-module-scss-module__Mv1anG__linksHeader",
  "lockedImage": "Video-module-scss-module__Mv1anG__lockedImage",
  "lockedText": "Video-module-scss-module__Mv1anG__lockedText",
  "name": "Video-module-scss-module__Mv1anG__name",
  "notes": "Video-module-scss-module__Mv1anG__notes",
  "outerContainer": "Video-module-scss-module__Mv1anG__outerContainer",
  "overallContainer": "Video-module-scss-module__Mv1anG__overallContainer",
  "relatedVideo": "Video-module-scss-module__Mv1anG__relatedVideo",
  "relatedVideoImage": "Video-module-scss-module__Mv1anG__relatedVideoImage",
  "relatedVideoName": "Video-module-scss-module__Mv1anG__relatedVideoName",
  "relatedVideos": "Video-module-scss-module__Mv1anG__relatedVideos",
  "relatedVideosBlock": "Video-module-scss-module__Mv1anG__relatedVideosBlock",
  "relatedVideosHeader": "Video-module-scss-module__Mv1anG__relatedVideosHeader",
  "result": "Video-module-scss-module__Mv1anG__result",
  "results": "Video-module-scss-module__Mv1anG__results",
  "upcomingText": "Video-module-scss-module__Mv1anG__upcomingText",
  "videoPadlock": "Video-module-scss-module__Mv1anG__videoPadlock",
  "videoWrapper": "Video-module-scss-module__Mv1anG__videoWrapper",
});
